import {axiosInstance} from "./base"

/* Organization tree (Lot 4 — SaaS multi-tenant).
   Entities are tenant-scoped server-side: the API only ever returns the current
   client's tree, so no client filtering is needed here. */

/* ---- Entities ---- */

export function getEntitiesQry(params) {
    return axiosInstance.get("api/entities/", {params})
}

export function getEntityQry(id) {
    return axiosInstance.get(`api/entities/${id}/`, {})
}

export function postEntityQry(data) {
    return axiosInstance.post("api/entities/", data, {})
}

export function patchEntityQry(id, data) {
    return axiosInstance.patch(`api/entities/${id}/`, data, {})
}

export function deleteEntityQry(id) {
    return axiosInstance.delete(`api/entities/${id}/`, {})
}

/* Re-parent a node. parentId = null makes it a root. */
export function moveEntityQry(id, parentId) {
    return axiosInstance.post(`api/entities/${id}/move/`, {parent: parentId}, {})
}

/* Attach a user to an entity. */
export function attachUserToEntityQry(id, userId) {
    return axiosInstance.post(`api/entities/${id}/attach-user/`, {user: userId}, {})
}

/* List the users directly attached to an entity (searchable + paginated). */
export function getEntityMembersQry(id, params) {
    return axiosInstance.get(`api/entities/${id}/members/`, {params})
}

/* Detach a user from an entity (user.entity -> null). */
export function detachUserFromEntityQry(id, userId) {
    return axiosInstance.post(`api/entities/${id}/detach-user/`, {user: userId}, {})
}

/* ---- Zones (used by F3 and by notification preferences) ---- */

export function getZonesQry(params) {
    return axiosInstance.get("api/zones/", {params})
}

export function postZoneQry(data) {
    return axiosInstance.post("api/zones/", data, {})
}

export function patchZoneQry(id, data) {
    return axiosInstance.patch(`api/zones/${id}/`, data, {})
}

export function deleteZoneQry(id) {
    return axiosInstance.delete(`api/zones/${id}/`, {})
}
